module.exports = __webpack_public_path__ + "img/image-after-upload.d358b84e.png";